import { render, staticRenderFns } from "./ChatHeaderMessage.vue?vue&type=template&id=f02ffac2&scoped=true"
import script from "./ChatHeaderMessage.vue?vue&type=script&lang=js"
export * from "./ChatHeaderMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02ffac2",
  null
  
)

export default component.exports